import { render, staticRenderFns } from "./AdminVipGroupActions.vue?vue&type=template&id=0c18a735&"
import script from "./AdminVipGroupActions.vue?vue&type=script&lang=ts&"
export * from "./AdminVipGroupActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports